<template>
    <div>
        <span class="text">{{ row[column.key] }}%</span>
        <span class="text" v-if="row['colonel_type'] === '1' && column['showPay']">{{ '(支出' + row['disburse_commission_rate'] + '%)' }}</span>
    </div>
</template>

<script>
import mixin from "@/components/tableCells/mixin";

export default {
    name: "serviceRateCell",
    mixins: [mixin]
}
</script>

<style scoped>
.text {
    overflow: hidden;
    text-overflow:ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
</style>
